// extracted by mini-css-extract-plugin
export var Jobs = "jobs-module--Jobs--GuZOw";
export var BigText = "jobs-module--BigText--b7uMx";